module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid2_800x658.0d76f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid2_800x658.jpg
// module id = l4bS
// module chunks = 0